<template>
  <AppCheckbox :rules="[required]">
    <template #label>
      <span v-html="$tt('agree_terms')" />
    </template>
  </AppCheckbox>
</template>

<script setup lang="ts">
const { required } = useValidation();
</script>